import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const topViewIcon = createIconDefinition(
  'topViewIcon',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.9173 13.3337V11.667L11.2507 7.50033V2.91699C11.2507 2.22533 10.6923 1.66699 10.0007 1.66699C9.30898 1.66699 8.75065 2.22533 8.75065 2.91699V7.50033L2.08398 11.667V13.3337L8.75065 11.2503V15.8337L7.08398 17.0837V18.3337L10.0007 17.5003L12.9173 18.3337V17.0837L11.2507 15.8337V11.2503L17.9173 13.3337Z" fill="#232426" fill-opacity="0.87"/>
</svg>`,
);
